import { useState } from 'react';
import { createPlantillaCobranza } from '../../helpers/api_helper';

const useCreatePlantilla = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const createPlantilla = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await createPlantillaCobranza(data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to create plantilla: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { createPlantilla, loading, error };
};

export default useCreatePlantilla;